import React, { FC } from 'react';
import { Div, DivProps } from '@kizi/core-components';

export interface PercentageBarProps {
  innerWidth: number;
  innerColor?: string;
  containerProps?: DivProps;
}

export const PercentageBar: FC<PercentageBarProps> = ({
  innerWidth,
  innerColor = 'main.1',
  containerProps,
  ...restProps
}) => {
  return (
    <Div variant="percentageBar" {...containerProps} {...restProps}>
      <Div>
        <Div
          data-testid="percentage-bar-inner"
          height="inherit"
          borderRadius="inherit"
          backgroundColor={innerColor}
          width={`${innerWidth}%`}
          maxWidth="100%"
        ></Div>
      </Div>
    </Div>
  );
};
